import { render, staticRenderFns } from "./editDonasi.vue?vue&type=template&id=822533c4&"
import script from "./editDonasi.vue?vue&type=script&lang=js&"
export * from "./editDonasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports